export default __webpack_public_path__ + "static/media/wallpaper_bg1.11fbe208.jpg";